@if (progress$ | async; as progress) {
   <div
      class="app-basic-progressbar expandable flex flex-col gap-5"
      [class.open]="progress.isLoading"
   >
      <div class="app-progressbar app-progressbar-small flex flex-col gap-2">
         <div class="flex items-end justify-between">
            <span class="text-xs">{{ 'progressbarLabel_download' | translate }}: {{ 'progressbarStatus_' + progress.status | translate }}</span>
            <div class="flex items-end gap-2 text-xs">
               <span>{{ 'progressbarLabel_loaded' | translate }}:</span>
               <span>{{ progress.percentage }}%</span>
            </div>
         </div>
         <mat-progress-bar
            class="app-progressbar-control"
            [mode]="progress.mode"
            [value]="progress.percentage"
            [style.--mdc-linear-progress-active-indicator-color]="
               progress.status === 'error' ? '#d50000' : progress.percentage >= 100 ? '#57c32c' : 'var(--app-accent-2)'
            "
            [class.complete]="progress.status === 'complete' || progress.percentage >= 100"
            [class.error]="progress.status === 'error'"
         >
         </mat-progress-bar>
      </div>
   </div>
}
